module.exports = __webpack_public_path__ + "static/media/lc.0f22dfca.svg";